module.exports = "<p>\n  log does not work yet\n</p>\n<button (click)=\"resetScenesInDatabase()\">reset scenes</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/app/log/log.component.html
// module id = ../../../../../src/app/log/log.component.html
// module chunks = main